import { EAppEnv } from "@timeedit/types/lib/enums/appEnv.enum";
import { ERegion } from "@timeedit/types/lib/enums/region.enum";

/**
 * URLs of the TimeEdit services the client calls directly, resolved from the
 * environment and region reported by the TE server (`appContext.env`).
 */

const REGION_SUBDOMAINS: Record<ERegion, string> = {
    [ERegion.EU_EES]: "eu",
    [ERegion.ANZ]: "anz",
    [ERegion.SGP]: "sgp",
    [ERegion.UK]: "uk",
};

const ENV_DOMAINS: Record<Exclude<EAppEnv, EAppEnv.DEVELOPMENT>, string> = {
    [EAppEnv.BETA]: "timeedit.dev",
    [EAppEnv.STAGING]: "timeedit.io",
    [EAppEnv.TEST]: "test.timeedit.net",
    [EAppEnv.PRODUCTION]: "timeedit.net",
};

const isDevelopment = (env: string | undefined) =>
    process.env.NODE_ENV === "development" || env === EAppEnv.DEVELOPMENT;

/**
 * `https://<service>.<region>.<env domain>`, e.g. `https://preferences.eu.timeedit.dev`.
 * Unknown values fall back to the EU region and the production domain.
 */
export const getRegionalServiceUrl = (
    service: string,
    env: string | undefined,
    region: string | undefined
): string => {
    const subdomain = REGION_SUBDOMAINS[region as ERegion] ?? REGION_SUBDOMAINS[ERegion.EU_EES];
    const domain = ENV_DOMAINS[env as keyof typeof ENV_DOMAINS] ?? ENV_DOMAINS[EAppEnv.PRODUCTION];
    return `https://${service}.${subdomain}.${domain}`;
};

/** The shared-ai backend serving the in-app assistant. Override locally with `SHARED_AI_URL` */
export const getSharedAiUrl = (env: string | undefined, region: string | undefined): string => {
    if (isDevelopment(env)) {
        return (
            process.env.SHARED_AI_URL ??
            getRegionalServiceUrl("shared-ai-backends-mcprst", EAppEnv.BETA, ERegion.EU_EES)
        );
    }
    return getRegionalServiceUrl("shared-ai-backends-mcprst", env, region);
};
